import React from "react";
import { Paper, Stack } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { Panel, PanelPosition } from "reactflow";

interface ControlPanelProps {
  /** The buttons or other controls to display */
  children: React.ReactNode;

  /** Layout direction — maps to MUI flex direction */
  direction?: "horizontal" | "vertical";

  /** Position on the ReactFlow canvas */
  position?: PanelPosition;

  /** Space between buttons */
  gap?: number;

  /** Optional alignment within the panel */
  align?: "center" | "flex-start" | "flex-end";
}

/**
 * A thin, minimal white control panel that can be positioned
 * over the React Flow canvas — like the built-in zoom/fit controls.
 */
const ControlPanel: React.FC<ControlPanelProps> = ({
  children,
  direction = "horizontal",
  position = "top-left",
  gap = 0,
  align = "center",
}) => {

  const flexDirection = direction === "horizontal" ? "row" : "column";

  return (
    <Panel position={position} style={{ padding: 0, margin: 5 }}>
      <Stack
        direction={flexDirection}
        spacing={gap}
        alignItems={align}
        justifyContent="center"
      >
        {children}
      </Stack>    
    </Panel>
  );
};

export default ControlPanel;
